import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { IconButton, StepConnector, Tooltip } from '@material-ui/core';
import { CheckCircleOutlineOutlined, PlayForWork, RadioButtonUncheckedOutlined } from '@material-ui/icons';
import { DocGenerator } from 'utils';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const StyledConnector = withStyles({
  // active: {
  //   '& $line': {
  //     borderColor: '#4A3BFF',
  //   },
  // },
  vertical: {
    padding: '0 0 6px',
    marginLeft: '0.7rem',
  },
  completed: {
    '& $line': {
      borderColor: '#4A3BFF',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderRadius: 1,
    borderLeftWidth: 3,
    margin: 0,
  },
})(StepConnector);

function StyledIcon(props) {
  const { active, completed } = props;
  return (
    <div>
      {completed ? <CheckCircleOutlineOutlined fontSize='medium' color='primary' /> : <RadioButtonUncheckedOutlined fontSize='medium' style={{ color: '#0000008a' }} />}
    </div>
  );
}

export default function ShowProgress({ activeDispute, IS_END_USER, timeLines }) {
  const classes = useStyles();

  const activeStep = activeDispute.status === 'closed' ? timeLines.length : timeLines.length - 1;

  const handleDownloadResponse = (profile_type, downloadKey, disputeId) => {
    DocGenerator(disputeId, profile_type, downloadKey);
  }

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical" connector={<StyledConnector />}>
        {timeLines.map((label, index) => (
          <Step key={label?.id}>
            <StepLabel StepIconComponent={StyledIcon}>
              <span style={{ display: 'flex', gap: '8px' }}>
                <span style={(label?.status === 'completed') ? { color: '#4A3BFF' } : { color: '#0000008a' }}>{label?.heading}</span>
                {label?.download && (
                  <Tooltip title='Download Response' placement='bottom'>
                    <IconButton
                      onClick={() => handleDownloadResponse(label?.download, label?.download_key, activeDispute?.id)}
                      style={{ padding: 0 }}
                    >
                      <PlayForWork color='primary' />
                    </IconButton>
                  </Tooltip>
                )}
              </span>
              <span style={{ fontSize: '0.8rem', color: '#aaaaaa' }}>
                {format(new Date(label?.created_at), "dd MMMM | h:mm a")}
              </span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
